import { render, staticRenderFns } from "./ComplementaryDialog.vue?vue&type=template&id=79da01fa&scoped=true&"
import script from "./ComplementaryDialog.vue?vue&type=script&lang=js&"
export * from "./ComplementaryDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComplementaryDialog.vue?vue&type=style&index=0&id=79da01fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79da01fa",
  null
  
)

export default component.exports